import { render, staticRenderFns } from "./ncrValue.vue?vue&type=template&id=76cbe480&"
import script from "./ncrValue.vue?vue&type=script&lang=js&"
export * from "./ncrValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports